import React from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { SizeOverride } from '@rover/components/src/Trustpilot';
import TrustPilotContainer from '@rover/components/src/Trustpilot/TrustPilotContainer';
import { Flex, Link, Paragraph } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import type { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest/model/countryConfiguration';

type SectionProps = React.ComponentProps<typeof Section>;

export type RoverProtectProps = {
  countryConfig: Pick<
    CountryConfiguration,
    'hideBackgroundCheckVerbiage' | 'formattedVetCareReimbursementAmount'
  >;
  isTraining?: boolean;
};

const RoverProtectCondensed: React.FC<RoverProtectProps & SectionProps> = ({
  countryConfig,
  isTraining = false,
  ...sectionProps
}) => {
  const vetCareReimbursementAmount =
    countryConfig?.formattedVetCareReimbursementAmount || '$25,000';

  const backgroundCheckStatement = isTraining
    ? 'Every trainer passes a background check and provides dog training credentials.' // DEV-104195: Translate
    : t`Every sitter passes an enhanced background check.`;
  const idVerificationStatement = t`Feel secure with ID-verified sitters and ${vetCareReimbursementAmount} in eligible vet care.`;
  return (
    <Section background="accent_secondary" py="5x" {...sectionProps}>
      <>
        <Paragraph webProps={{ maxWidth: '100%' }} textAlign="center" mb="1x">
          {countryConfig.hideBackgroundCheckVerbiage
            ? idVerificationStatement
            : backgroundCheckStatement}
          {!isTraining && (
            <>
              {' '}
              <Link href="/rover-protect/" target="_blank" rel="noopener noreferrer">
                <Trans>Learn about RoverProtect</Trans>
              </Link>
            </>
          )}
        </Paragraph>
        <Flex justifyContent="center">
          <TrustPilotContainer sizeOverride={SizeOverride.small} m="0x" pb="0x" />
        </Flex>
      </>
    </Section>
  );
};

export default RoverProtectCondensed;
